export const HOME_ROUTE = '/'
export const CONTACT_ROUTE = '/contact/'
export const BLOG_ROUTE = '/blog/'
export const KNOWLEDGE_ROUTE = '/knowledge/'
export const BYTES_ROUTE = 'https://buildwithstudio.com/bytes'
export const PORTFOLIO_ROUTE = '/portfolio/'
export const SERVICES_ROUTE = '/services/'
export const ABOUT_ROUTE = '/about/'
export const VENTURES_ROUTE = '/ventures/'

export const MUSTARD_PROJECT_ROUTE = '/portfolio/mustard/'
export const CREATIVELY_PROJECT_ROUTE = '/portfolio/creatively/'
export const LIVE_PROJECT_ROUTE = '/portfolio/live/'
export const ALKEME_PROJECT_ROUTE = '/portfolio/alkeme/'
export const SPIRITUNE_PROJECT_ROUTE = '/portfolio/spiritune/'
export const QVC_PROJECT_ROUTE = '/portfolio/qvc/'
export const BRCC_PROJECT_ROUTE = '/portfolio/black-rifle-coffee-company/'
export const PLEXUS_PROJECT_ROUTE = '/portfolio/plexus/'
export const ALICE_AND_OLIVIA_PROJECT_ROUTE = '/portfolio/alice-+-olivia/'
export const MOE_PROJECT_ROUTE = '/portfolio/moe/'
export const SOMEWHERE_GOOD_PROJECT_ROUTE = '/portfolio/somewhere-good/'
export const REFER_PROJECT_ROUTE = '/portfolio/refer/'
export const BETQL_PROJECT_ROUTE = '/portfolio/betql/'
export const FAHLO_PROJECT_ROUTE = '/portfolio/fahlo/'

// Services
export const SERVICES_BRANDING_ROUTE = '/services/creative-branding-agency/'
export const SERVICES_ANDROID_ROUTE = '/services/android-development-company/'
export const SERVICES_IOS_ROUTE = '/services/ios-app-development-services/'
export const SERVICES_BACKEND_ROUTE = '/services/backend-development-services/'
export const SERVICES_FRONTEND_ROUTE =
  '/services/front-end-development-company/'
export const SERVICES_ANALYTICS_ROUTE = '/services/analytics-implementation/'
export const SERVICES_DIGITAL_TRANSFORMATION_ROUTE =
  '/services/digital-transformation/'
export const SERVICES_USER_RESEARCH_ROUTE = '/services/user-research-services/'
export const SERVICES_AR_ROUTE = '/services/ar-app-development/'
export const SERVICES_PERFORMANCE_MARKETING_ROUTE =
  '/services/performance-marketing-agency/'
export const SERVICES_MOBILE_APP_ROUTE =
  '/services/mobile-app-development-company/'
export const SERVICES_WEB_DEVELOPMENT_ROUTE =
  '/services/web-development-company/'

// Specialties
export const RESTAURANT_APP_DEVELOPMENT_ROUTE =
  '/specialties/restaurant-app-development/'
export const CUSTOM_ECOMMERCE_DEVELOPMENT =
  '/specialties/custom-ecommerce-development/'
export const SPORTS_APP_DEVELOPMENT = '/specialties/sports-app-development/'
export const FINTECH_APP_DEVELOPMENT = '/specialties/fintech-app-development/'
export const VISION_PRO_DEVELOPMENT_COMPANY =
  '/specialties/vision-pro-development-company'
export const HEALTHCARE_APP_DEVELOPMENT_COMPANY =
  '/specialties/healthcare-app-development-company'
export const IOT_DEVELOPMENT_SERVICES_ROUTE =
  '/specialties/iot-development-services/'
export const LIVE_STREAMING_SHOPPING_DEVELOPMENT_ROUTE =
  '/specialties/live-streaming-shopping-development/'
export const AI_DEVELOPMENT_COMPANY_ROUTE =
  '/specialties/ai-development-company/'
export const FITNESS_WELLNESS_APP_DEVELOPMENT_ROUTE =
  '/specialties/fitness-wellness-app-development-company/'

export const INSTAGRAM_ROUTE = 'https://www.instagram.com/buildwithstudio/'
export const LINKEDIN_ROUTE =
  'https://www.linkedin.com/company/buildwithstudio/'
export const DRIBBBLE_ROUTE = 'https://dribbble.com/buildwithstudio'
export const ANGELLIST_ROUTE = 'https://angel.co/company/buildwithstudio/'

export const SITEMAP_ROUTE = '/sitemap-index.xml'
